<template>
    <div class="parking-block">
        <div class="parking__title-block">
            <h3 class="parking__title">
                Паркинги и&nbsp;кладовые <span>{{ numberOfItems.parking +  numberOfItems.pantry}}</span>
            </h3>
            <div class="parking__switch-plan">
                <button
                    :class="['parking-tabs__tab', {'is-active': isActiveVisual}]"
                    data-tab="visual"
                    @click.prevent="clickTabVisual"
                >
                    <span>Подбор&nbsp;</span>на плане
                </button>
                <div
                    :class="['parking-tabs__radio', {'is-switched': isActiveList}]"
                    @click="changeState"
                    ></div>
                <button
                    :class="['parking-tabs__tab', {'is-active': isActiveList}]"
                    data-tab="list"
                    @click.prevent="clickTabList"
                >
                    <span>Подбор&nbsp;</span>по параметрам
                </button>
            </div>
        </div>

        <p v-if="parkingRenderUnavailable" class="parking__render-notice">
            Схема паркинга пока недоступна. Используйте подбор по параметрам.
        </p>
        <Sly v-if="isActiveVisual && !parkingRenderUnavailable" isParking = true />

        <div>
            <div v-if="isActiveVisual" class="parking__section-selector">
                <div class="parking-canvas__select">
                    <Select
                        :list="filters.buildings"
                        :isStep="'parking'"
                        @selectric-select="selectrichange($event)"
                        ref='buildingWrapper'
                    />
                </div>
            </div>
        </div>

        <div class="parking-visual__content">
            <div class="parking-wrapper">
                <Results/>
            </div>
        </div>

        <Legend v-if="isActiveVisual"/>
    </div>
</template>

<style lang='scss'>
    @import "./Parking.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import callbackCall from 'components/form/config/call';
import Form from 'components/form';
import Legend from '../../components/Parking/Legend/Legend.vue';
import Observer from 'common/scripts/observer';
import parkingParams from 'components/callback/parking-params.twig';
import Popup from 'components/popup';
import Results from '../../components/Parking/Results/Results.vue';
import Select from 'components/forms/select/select-parking.vue';
import Sly from '../../components/Sly/Sly';
import store from '../../store';

const observer = new Observer();

export default {
    data: () => {
        return {
            isFilterOpen  : false,
            isDesctop     : window.innerWidth >= 960,
            footer        : null,
            isActiveVisual: window.innerWidth >= 960,
            isActiveList  : window.innerWidth < 960,
            selected      : ''
        };
    },

    components: {
        Sly,
        Results,
        Select,
        Legend
    },

    computed: {...mapGetters({
        parkingRenderUnavailable: 'GET_PARKING_RENDER_UNAVAILABLE',
        isReady      : 'GET_IS_READY',
        isPinch      : 'GET_IS_PINCH',
        filters      : 'GET_FILTERS',
        parkings     : 'GET_PARKINGS',
        redirect     : 'GET_REDIRECT',
        numberOfItems: 'GET_NUMBER_OF_ITEMS',
        parkingType  : 'GET_PARKING_TYPE',
        buildings    : 'GET_BUILDING'
    })},

    watch: {
        parkingRenderUnavailable(unavailable) {
            if (unavailable) {
                this.isActiveVisual = false;
                this.isActiveList = true;
            }
        }
    },

    mounted() {
        if (this.parkingRenderUnavailable) {
            this.isActiveVisual = false;
            this.isActiveList = true;
        }

        this.subscribes();
        this.selected = this.$route.params.buildingId;

        window.addEventListener('scroll', this.onScroll, true);
    },

    methods: {
        ...mapActions(['parkingSend', 'changeStatePinch', 'closeSelected']),

        subscribes() {
            observer.subscribe('parkingClick', (data) => {
                if (data) {
                    this.openPopup(data);
                }
            });

            observer.subscribe('selectorChange', ({id}) => {
                if (id) {
                    this.selected = id;
                }
            });
        },

        onScroll(event) {
            const sorting = document.querySelector('.j-parking-list__cards-sort');
            const mobileFilter = document.querySelector('.j-parking-tabs__mobile-filter');

            if (event.target.scrollTop > 200) {
                sorting.classList.add('is-static');
                mobileFilter.classList.add('is-static');
            } else {
                sorting.classList.remove('is-static');
                mobileFilter.classList.remove('is-static');
            }
        },

        currentBuildingId() {
            return Number(this.$route.params.buildingId);
        },

        clickTabVisual() {
            if (this.parkingRenderUnavailable) {
                return;
            }
            observer.publish('clickTabVisual');
            this.isActiveVisual = true;
            this.isActiveList = false;
            this.changeStatePinch(true);
        },

        clickTabList() {
            observer.publish('clickTabList');
            this.isActiveVisual = false;
            this.isActiveList = true;
        },

        changeState() {
            return this.isActiveList ? this.clickTabVisual() : this.clickTabList();
        },

        openPopup(data) {
            const button = document.createElement('button');

            button.classList.add('j-popup-callback-call');
            button.setAttribute('data-popup-id', '#parking-callback-call');
            button.setAttribute('data-href', '#parking-callback-call');
            button.setAttribute('data-type', 'parking');
            button.setAttribute('data-parking-id', data.element);
            button.setAttribute('data-parking-title', data.title);

            const popupOptions = {
                openButtons         : [button],
                closeButtonAriaLabel: 'Закрыть форму обратной связи',
                template            : 'classic',
                templateContent     : 'action',
                openLoadPage        : false
            };

            const popupCallback = new Popup(popupOptions);

            popupCallback.init();

            button.click();

            this.addDataToPopup(popupCallback, data.element);

            observer.subscribe('createPopup', (popup, instance) => {
                if (!popup) {
                    return;
                }

                const callbackSelector = popup.querySelector('.j-form-callback');

                if (callbackSelector) {
                    if (window.sessionStorage.getItem('callback-init') === null) {
                        window.sessionStorage.setItem('callback-init', 'true');
                    } else {
                        return;
                    }

                    const form = new Form();
                    const select = new Select();
                    const callbackSelect = callbackSelector.querySelector('.j-select');

                    if (callbackSelect) {
                        select.init({
                            element      : callbackSelect,
                            disableSearch: true
                        });
                    }

                    callbackCall(form, callbackSelector, instance);

                    observer.subscribe('successForm', () => {
                        // Закрываем попап через 3сек
                        const send = setTimeout(() => {
                            observer.publish('sendForm', instance);
                        }, 3000);

                        // Если попап был закрыт ранее через кнопку, то обнуляем интервал.
                        observer.subscribe('closePopup', () => {
                            clearTimeout(send);
                        });
                    });
                }
            });
        },

        addDataToPopup(popup, id) {
            const openedPopup = popup.popup;
            const parkingParamsDiv = openedPopup.querySelector('.j-parking-params');
            const item = this.parkings.filter((elem) => {
                return elem.id === id;
            });

            const descriptionID = item[0].id;
            const descriptionTitle = item[0].title;
            const descriptionType = item[0].type;
            const descriptionArea = item[0].area;
            const descriptionBuilding = item[0].buildingTitle;
            const descriptionPrice = item[0].price;
            const parkingType = item[0].isParking ? 'Паркинг' : 'Кладовая';

            parkingParamsDiv.innerHTML = parkingParams({
                descriptionID,
                descriptionTitle,
                descriptionType,
                descriptionArea,
                descriptionBuilding,
                descriptionPrice,
                parkingType
            });

            observer.subscribe('closePopup', () => {
                parkingParams.innerHTML = '';
            });
        },

        selectrichange() {
            const buildingId = Number(this.selected);

            if (buildingId === this.currentBuildingId()) {
                return;
            }

            const floors = Object.keys(this.filters.buildings).map((i) => {
                return {[i]: this.filters.buildings[i]};
            });

            let floorId = '';

            floors.forEach((item) => {
                for (const obj in item) {
                    if (Number(item[obj].id) === Number(buildingId)) {
                        floorId = item[obj].floorId;
                    }
                }
            });

            let url = this.$route.path.replace(/building[/]\d*/, `building/${buildingId}`);

            if (floorId) {
                url = url.replace(/floor[/]\d*/, `floor/${floorId}`);
            }

            this.$router.push(url);

            const body = {
                step    : 'parking',
                building: this.selected,
                floor   : floorId || '',
                cleanURL: true
            };

            observer.publish('selectorVisualChange', buildingId);

            this.parkingSend(body);
        }
    },

    beforeRouteEnter(to, from, next) {
        /**
         * Отправляет данные на сервер.
         */

        const body = {
            step    : 'parking',
            floor   : to.params.floorId || '',
            building: to.params.buildingId || ''
        };

        store.dispatch('parkingSend', body).then(() => {
            if (store.getters.GET_REDIRECT && !to.params.floorId) {
                const path = window.location.pathname;
                const currentPath = path.substr(-1) === '/' ? path.slice(0, -1) : path;

                window.location.pathname = `${currentPath}${store.getters.GET_REDIRECT}`;

                return;
            }
            next();
        });
    }
};
</script>
